import script from "./RestoreFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestoreFrame.vue?vue&type=script&setup=true&lang=ts"

import "./RestoreFrame.vue?vue&type=style&index=0&id=3efdcc72&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efdcc72"]])

export default __exports__